<template>
  <div>

    <AuditTable :items="getAuditHistory" :loading="auditHistoryLoading" :server-items-length="auditHistory.config.paginationCount" @updatePagination="updatePagination">
      <template #title>
        <span class="mr-1">Retention Lead Audit</span>
        <BaseInfoTooltip top>The history of the retention lead</BaseInfoTooltip>
      </template>
    </AuditTable>
    
  </div>
</template>

<script>
  import { mapState,mapActions,mapGetters } from "vuex";

  import AuditTable from '@/components/Globals/AuditTable';

  export default {
    components: { AuditTable },

    props: ['lead_id'],

    computed: {
      ...mapState('retention',['auditHistory','auditHistoryLoading']),
      ...mapGetters('retention',['getAuditHistory']),
    },

    methods: {
      ...mapActions('retention',['updateAuditPagination']),

      updatePagination(options) {
        this.updateAuditPagination({ id:this.lead_id, options});
      }
    }
  }
</script>

<style lang="scss" scoped></style>
